import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Button from '@material-ui/core/Button';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import FormDialog from 'components/FormDialog';
import AdminUploadBulkOrderForm from '../AdminBulkOrderForm/AdminUploadBulkOrderForm';

export default function AdminOrderUploadButton({ mode = 'edit', ...props }) {
  const [open, setOpen] = useState(false);
  const title = '上傳訂單';
  return (
    <React.Fragment>
      <Button
        aria-label={mode}
        size={'small'}
        variant={'text'}
        color={'inherit'}
        onClick={() => {
          if (!open) {
            setOpen(true);
          }
        }}
        style={{ marginLeft: 5 }}
      >
        <CloudUploadIcon fontSize="small" style={{ marginRight: 3 }}/>
        {title}
      </Button>
      {open &&
        <FormDialog
          title={title}
          openOnInit={true}
          fullScreen={true}
          onClose={() => {
            setOpen(false);
          }}
          exitConfirm={true}
        >
          <AdminUploadBulkOrderForm
            onComplete={(data) => {
              setOpen(false);
            }}
          />
        </FormDialog>}
    </React.Fragment>
  );
}

AdminOrderUploadButton.propTypes = {
  title: PropTypes.string,
  mode: PropTypes.string,
  type: PropTypes.string,
  size: PropTypes.number,
  variant: PropTypes.string,
  item: PropTypes.object,
  onUpdate: PropTypes.func,
  fullScreen: PropTypes.bool,
  open: PropTypes.bool,
  color: PropTypes.string,
  exitConfirm: PropTypes.bool,
};
